import { path } from '../../Paths';
import { requestFactory } from '../../RequestFactory';
import { toFormData } from '../../../../Utils';
import { requestMethods } from '../../../../Constants/requestMethods';

export const getProfile = profileId => {
    const url = path.create().getUserInfo(profileId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const checkInUser = (classId, userId, planMemberId) => {
    const url = path.create().checkInUser(classId, userId, planMemberId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};

export const checkOutUser = (classId, userId, planMemberId) => {
    const url = path.create().checkOutUser(classId, userId, planMemberId);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateProfileClass = (classId, data) => {
    const url = path.create().updateClass(classId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const createProfileClass = data => {
    const url = path.create().createClass();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const getActivity = (userId, offsetId, offsetDate) => {
    const url = path.create().getAllActivites(userId, offsetId, offsetDate);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getClassesBookers = classId => {
    const url = path.create().getClassBookers(classId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getClasses = (userId, offsetId, offsetDate) => {
    const url = path.create().getProfileClasses(userId, offsetId, offsetDate);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getClassesByDate = (userId, offsetId, offsetDate, filterDate) => {
    const url = path.create().getClassesByDate(userId, offsetId, offsetDate, filterDate);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getClassMembers = classId => {
    const url = path.create().getClassMembers(classId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getFollowers = userId => {
    const url = path.create().getProfileFollowers(userId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/ProfileApi/profileRequestConfigs.js